import { ExecutePaymentResponseDto } from '@tiendanube/common';
import { PaymentStatusAlertFailed } from 'domains/Billing/Checkout/components/PaymentStatusAlert/components/PaymentStatusAlertCreditCard/components';

interface CreditCardStatusAlertFailedProps {
  creditCardPaymentData: ExecutePaymentResponseDto | undefined;
}

function AlertFailed({
  creditCardPaymentData,
}: CreditCardStatusAlertFailedProps) {
  if (
    !creditCardPaymentData ||
    creditCardPaymentData?.successfulExecution === true
  )
    return null;

  return (
    <PaymentStatusAlertFailed
      payment={creditCardPaymentData.payment}
      errorCode={creditCardPaymentData.errorCode}
      isExternalContext={false}
      isFromRecurrentPayment={false}
      isFromCreditCardForm
      requiredChangeMethod={false}
    />
  );
}

export default AlertFailed;
